<template>
    <div id="footer" class="position-fixed black-bg">
        <div class="container">
            <div class="col-sm-12">
                <div class="column-inner">
                    <div class="wrapper footer-wrapper text-center">
                        <div class="footer-headline text-center">
                            <h6 class="white-color">{{dataText.title}}</h6>
                        </div>
                        <div class="spacer-md"></div>
                        <div class="footer-info text-center">
                            <p>{{dataText.a}}: Ciscuttijeva ulica 15, 52 100 Pula, Hrvatska</p>
                            <p>{{dataText.tel}}:<a href="tel:+385911921818" class="trans-300-ms"> +385 91 192 1818</a></p>
                            <p>E: <a href="mailto:info@h3.solutions" class="trans-300-ms">info@h3.solutions</a></p>
                        </div>
                        <div class="spacer-md"></div>
                        <div class="footer-social">
                            <div class="footer-headline text-center">
                                <h6 class="white-color">{{dataText.subTitle}}</h6>
                            </div>
                            <a class="fb trans-500-ms bg-img-atr" href="https://www.facebook.com"></a>
                            <a class="yt trans-500-ms bg-img-atr" href="https://www.youtube.com"></a>
                            <a class="mail trans-500-ms bg-img-atr" href="mailto:info@h3.solutions"></a>
                        </div>
                        <div class="spacer-sm"></div>
                        <p class="white-color">Copyright H3 Solutions 2020 &copy;</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data () {
            return {
                dataText: this.$store.state.HR.components.footer
            }
        }
    }
</script>

<style scoped>
    #footer {
        height: 330px;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1;
    }
    #footer .footer-info p {
        margin-bottom: 0;
        color: #fff;
    }
    #footer .footer-info p a {
        color: #fff;
    }
    #footer .footer-info p a:hover {
        color: #5666AE;
    }
    .footer-wrapper {
        padding: 25px 0;
    }
    .footer-headline h6 {
        text-transform: uppercase;
    }
    .footer-social a {
        display: inline-block;
        height: 32px;
        width: 32px;
        border-radius: 50px;
        margin-right: 15px;
    }
    .footer-social .fb {
        background-image: url("../assets/icons/fb_light.png");
    }
    .footer-social .yt {
        background-image: url("../assets/icons/youtube_light.png");
    }
    .footer-social .mail {
        background-image: url("../assets/icons/email_light.png");
    }
    .footer-social .fb:hover {
        background-image: url("../assets/icons/fb_color.png");
    }
    .footer-social .yt:hover {
        background-image: url("../assets/icons/youtube_color.png");
    }
    .footer-social .mail:hover {
        background-image: url("../assets/icons/email_color.png");
    }

</style>